// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox__container___-NGac","colorPrimary":"Checkbox__colorPrimary___UwiNp","isSelected":"Checkbox__isSelected___h3TNa","isDisabled":"Checkbox__isDisabled___QnK6x"};